var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.218,
    height: 21,
    viewBox: "0 0 21.218 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    "data-name": "Path 81",
    d: "M10,2.5a10,10,0,0,0,8.66-5,10,10,0,0,0,0-10,10,10,0,0,0-8.66-5,10,10,0,0,0-8.66,5,10,10,0,0,0,0,10A10,10,0,0,0,10,2.5Zm0-15a.935.935,0,0,1,.938.938v4.375A.935.935,0,0,1,10-6.25a.935.935,0,0,1-.937-.937v-4.375A.935.935,0,0,1,10-12.5ZM8.75-3.75A1.25,1.25,0,0,1,10-5a1.25,1.25,0,0,1,1.25,1.25A1.25,1.25,0,0,1,10-2.5,1.25,1.25,0,0,1,8.75-3.75Z",
    transform: "translate(0.609 18)",
    fill: "#f7940b",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.f537d0e00e47ef402ce4a99ee006c98d.svg";
export { ForwardRef as ReactComponent };